<gl-button icon icon-center="glicon-dots" [id]="buttonId"></gl-button>
<gl-context-menu large (toggleMenu)="toggleMenu($event)" [target]="buttonId" [open]="dropdownVisible ? true : null">
  <div *ngIf="items && items.length; else customOptions" class="gl-context-menu__options">
    <ng-container *ngFor="let item of items; let i = index">
      <span
        *lmsProfileGuard="item.profile"
        class="gl-context-menu__options--item"
        [id]="item.id"
        [ngClass]="{
          alert:
            item.value === 'actions.delete' || item.value === 'actions.deleteClient' || item.value === 'actions.cancel'
        }"
        (click)="selectItem(item)"
        >{{ item.value | translate }}</span
      >
    </ng-container>
  </div>
  <ng-template #customOptions>
    <ng-content></ng-content>
  </ng-template>
</gl-context-menu>
